<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">资产类别设置</h2>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-button @click="append(false)" style="margin:10px 0;" size="mini" type="primary">添加大类</el-button>
        <el-tree class="asset-type-room" :data="dataList" :props="defaultProps" node-key="id" v-loading="formLoading">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ '(' +data.code+') ' + node.label }}</span>
            <span>
              <el-button type="text" size="mini" @click="() => append(data)" @click.stop>
                添加子类
              </el-button>

              <el-button type="text" size="mini" @click="() => edit(data)" @click.stop>
                修改
              </el-button>
              <el-button type="text" size="mini" @click="() => remove(node, data)" @click.stop>
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </el-col>
    </div>

    <div class="pop-room" v-if="addTypeStatus">
      <a href="javascript:;" @click="addTypeStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form" @submit.native.prevent>
            <el-form-item label="分类编码">
              <el-input v-model="form.code" @keyup.enter.native="addType()"></el-input>
            </el-form-item>
            <el-form-item label="分类名称">
              <el-input v-model="form.name" @keyup.enter.native="addType()"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button :loading="formLoading" @click="addType()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  export default {
    components: {
      // Attachments,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 组织架构
        organizationListData: [],
        // 是否可以切换公司
        noSelectOrganization: true,

        dataList: [],

        formType: 'create',
        form: {
          name: "",
          code: "",
          parentId: ""
        },
        defaultProps: {
          children: 'childs',
          label: 'name'
        },

        // 增加/修改 分类
        addTypeStatus: false,
        // loading状态
        formLoading: false,
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }

      this.getAssetType()
    },
    methods: {
      addType() {
        this.formLoading = true
        this.addTypeStatus = false

        // 添加分类
        let _url = this.formType == 'create' ? "/asset/classify/add" : "/asset/classify/edit"
        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          this.getAssetType()
        }, res => {
          this.formLoading = false
        })
      },
      getAssetType() {
        this.formLoading = true
        ajax.get('/asset/classify/list', '', (res) => {
          this.formLoading = false
          this.dataList = res.vo.array
        })
      },
      // 显示添加分类弹窗
      append(data) {
        this.addTypeStatus = true
        this.formLoading = false
        this.formType = 'create'

        this.form.code = ""
        this.form.name = ""
        if (data) {
          this.form.parentId = data.id
        } else {
          this.form.parentId = ""
        }
      },
      // 修改分类
      edit(data) {
        this.addTypeStatus = true
        this.formLoading = false
        this.formType = 'edit'

        this.form.code = data.code
        this.form.name = data.name
        this.form.classifyId = data.id
      },
      remove(node, data) {
        this.$confirm('此操作将永久删除该分类, 且同时会删除其子分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/asset/classify/del', {
            'classifyId': data.id,
          }, (res) => {
            this.$message.success('删除分类成功')
            this.getAssetType()
          })
        }).catch(() => {});
      },
    },
    watch: {

    },
    // beforeRouteLeave(to, from, next) {
    //   next()
    // },
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/type.vue